<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Store
	import { getDeviceState } from 'src/stores/device-runtime/states';
	import { authLockedDeviceModal } from 'src/stores/device-runtime/firmware-ui';
	//Design System components
	import { Button, ControlsContainer } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';
	//Helpers
	import { handleDeviceTurn } from 'src/helpers/handle_device_turn';
	import { capFirstChar } from 'src/helpers/utilities';
	import isDimmerWithCalibration from 'src/helpers/is_calibratable_dimmer';
	//Components
	import DeviceUpdatingView from './DeviceStateViewComponents/DeviceUpdatingView.svelte';
	import DeviceCalibratingView from './DeviceStateViewComponents/DeviceCalibratingView.svelte';
	import DeviceOfflineView from './DeviceStateViewComponents/DeviceOfflineView.svelte';
	import DeviceNoConnectionView from './DeviceStateViewComponents/DeviceNoConnectionView.svelte';
	import DeviceConnectedView from './DeviceStateViewComponents/DeviceConnectedView.svelte';
	import DeviceDisabledView from './DeviceStateViewComponents/DeviceDisabledView.svelte';
	import AuthenticateDevice from 'src/components/Devices/DeviceWizard/AuthenticateDevice.svelte';

	export let device: Device;
	export let status: any;
	export let uiState: any;
	export let isV2Component: boolean = false;

	let loadingCalibrationState = false;
	let authenticate = false;
	let _isDimmerWithCalibration = isDimmerWithCalibration(device.type);

	$: deviceStateStore = getDeviceState(device?.id);
	$: deviceState = $deviceStateStore;
	// $: uiState = deviceState;
	$: notAuthenticated = deviceState?.type === 9; //wall display
	$: authLockedDevice = deviceState?.type === 5; //gen 2 devices
</script>

{#if uiState?.type != 7}
	<div class="flex-full-height align-items-center justify-content-center width-full">
		{#if uiState.type == 3}
			<!-- Device fw updating -->
			<DeviceUpdatingView {device} {isV2Component} />
		{:else if uiState.type == 4}
			<!-- Device is calibrating -->
			<DeviceCalibratingView {device} {isV2Component} />
		{:else if uiState.type == 14 || uiState.type == 15}
			<!-- Device is disabled -->
			<DeviceDisabledView {device} />
		{:else if status?._updated && status?.online}
			<DeviceConnectedView {device} />
		{:else if status?._updated}
			<DeviceNoConnectionView {device} />
		{:else}
			<DeviceOfflineView {device} />
		{/if}
	</div>
{/if}
<div>
	<!-- uiState.type == 4 is the calibrating state -->
	{#if _isDimmerWithCalibration && uiState.type == 4}
		<ControlsContainer>
			<Button
				width="m"
				slot="first"
				loading={loadingCalibrationState}
				disabled={loadingCalibrationState}
				on:click={async () => {
					loadingCalibrationState = true;
					await handleDeviceTurn({ device }).then(() => {
						loadingCalibrationState = false;
					});
				}}
				>{$format('stop_calibration', {
					default: 'Stop calibration',
				})}</Button
			>
		</ControlsContainer>
	{/if}
</div>

<div class="d-flex width-full flex-direction-column align-items-center justify-content-center">
	{#if notAuthenticated}
		<Button
			type="warning"
			class="mt-m width-full"
			size="l"
			icon="fas fa-lock"
			disabled={device.shared}
			on:click={(e) => {
				e.stopPropagation();
				authenticate = true;
			}}
			>{capFirstChar(
				$format('button_authenticate', {
					default: 'authenticate',
				}),
			)}</Button
		>
	{:else if authLockedDevice}
		<Button
			aria-label={$format('button_unlock_device', {
				default: 'Button unlock device',
			})}
			class="mt-m width-full"
			size="l"
			icon="fas fa-lock"
			on:click={(e) => {
				e.stopPropagation();
				authLockedDeviceModal.set(device?.id);
			}}
		/>
	{/if}
</div>

{#if authenticate}
	<AuthenticateDevice {device} bind:showModal={authenticate} />
{/if}
